import { Injectable } from '@angular/core';
import { ListMetadata } from 'app/models/list-metadata.model';
import { Observable } from 'rxjs';
import { HttpClientService } from '../httpClient/httpclient.service';
import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Injectable()
export class RulesAppliedService {

  baseUrl = '/k7o/event/audit_rules_applied';
  constructor(
    private http: HttpClientService,
    private srvMessage: MessageService,
    private translate: TranslateService
  ) { }

  /**
   * Tramite metodo GET, restituisce la lista dei rules applied.
   * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
   */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    // Controllo se search è definito e non vuoto
    if (search && search.length > 0) {
      const hasStartDate = search.some(item => item.key === 'start_date');
      const hasEndDate = search.some(item => item.key === 'end_date');

      // Verifica se entrambi i campi sono presenti
      if (!hasStartDate || !hasEndDate) {
        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('audit.errorFiltersDateEmpty')
        });
        return;
      }
            // necessario perchè il componete app-kv-calendar non gestisce il formato YYYY-MM-DD
      const processedSearch = search.map(item => {
        if (item.key === 'start_date' || item.key === 'end_date') {
          // If already in YYYY-MM-DD format, don't re-format as it will cause INVALID_DATE
          if (moment(item.value, 'YYYY-MM-DD', true).isValid()) {
            return { ...item };
          }
          // Campaign3Kontable sends it as DD/MM/YYYY, convert to YYYY-MM-DD
          return { ...item, value: moment(item.value, 'DD/MM/YYYY').format('YYYY-MM-DD') };
        }
        return item;
      });
      search = processedSearch;
    } else {
      // Verifica se entrambi i campi sono presenti
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('audit.errorFiltersDateEmpty')
      });
      return;
    }

    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/list' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/audit/rulesapplied.service.ts